import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export default api;

// Logo VendiDirect — asset ufficiale (04/02/2026).
// `LOGO_URL_DARK`  → composizione completa (bg scuro + simbolo dorato) — usato nel badge circolare in dark mode
// `LOGO_URL_SYMBOL`→ solo simbolo W dorato su trasparente — usato in light mode (fondo bianco) e ovunque serva il simbolo isolato
// `LOGO_URL`       → alias di LOGO_URL_SYMBOL (default), per retro-compatibilità pagine che usano <img src={LOGO_URL} />
export const LOGO_URL_DARK = "/vendidirect_logo_dark_1024.png";
export const LOGO_URL_SYMBOL = "/vendidirect_logo_symbol_1024.png";
export const LOGO_URL = LOGO_URL_SYMBOL;

export const formatPrice = (n) => {
    if (n == null) return "—";
    return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
    }).format(n);
};

// Contratti affitto breve: prezzo = "a partire da" per notte/settimana/mese invece di prezzo fisso.
const SHORT_STAY_CONTRACT_TYPES = ["casa_vacanze", "bb", "affitto_breve"];
export const isShortStayContract = (property) => property?.transaction_type === "affitto" && SHORT_STAY_CONTRACT_TYPES.includes(property?.contract_type);

export const formatPropertyPrice = (property) => {
    if (!property) return "—";
    if (isShortStayContract(property) && property.price_period) {
        return `A partire da ${formatPrice(property.price)} / ${property.price_period}`;
    }
    return formatPrice(property.price);
};
